
import Vue from 'vue';

export default Vue.extend({
	name: 'ComplexBackgroundSideNav',
	props: {
		includeLeftBlobs: { type: Boolean, default: false },
		filter: { type: String, default: 'blur(100px)' },
	},
	data () {
		return {};
	},
});
